module.exports = __webpack_public_path__ + "aa1f2e25.svg";